import * as actionTypes from "./actionTypes";

export const setIsSegmentationView = (isSegmentationView) => {
   return {
      type: actionTypes.SET_IS_SEGMENTATION_VIEW,
      isSegmentationView,
   };
};
